<template>
	<div class="containerMain">
		<title-bar :topTitle="true" :topTitleText="`Dashboard de ${this.reportName}`"/>
		<div class="row between d-flex justify-content-end mr-2 mt-4 mb-0">
			<b-form-group label-size="1" label="Fecha Inicio" label-for="startDate" class="mr-2">
				<datepicker calendar-class="calendar" input-class="form-control cursor-pointer" v-model="startDate" name="startDate" format="dd/MM/yyyy" placeholder="Tocar para seleccionar fecha"></datepicker><br>
			</b-form-group>
			<b-form-group label-size="1" label="Fecha Fin" label-for="endDate" class="mr-2">
				<datepicker calendar-class="calendar" input-class="form-control cursor-pointer" v-model="endDate" name="endDate" format="dd/MM/yyyy" placeholder="Tocar para seleccionar fecha"></datepicker><br>
			</b-form-group>
			<b-button class="mr-2" style="height: 4rem;font-size: 1.6rem;" :disabled="!endDate || !startDate" variant="primary" @click="loadData()">Consultar</b-button>
		</div>
		<hr>
		<div class="col inner" v-if="dashboard && visits && visits.length > 0">
			<div class="row mt-4 mb-2">
				<div class="row d-flex align-items-start ml-2">
					<b-form-group label="Visitas">
						<b-form-radio-group
							buttons
	        		button-variant="outline-primary"
			        id="visits-group-1"
			        v-model="selectedVisit"
			        :options="visits"
			        name="radio-options"
			      ></b-form-radio-group>
					</b-form-group>
				</div>
				<div class="row ml-2">
					<b-form-input v-model="textFilterInputValue" placeholder="Escribe para filtrar" :autofocus="true"/>
				</div>
				<div class="table-responsive mt-4">
					<table class="table table-hover table-bordered" v-if="currentDashboard">
						<thead>
							<th>
								Colegios
							</th>
							<th v-for="(coach, index) in dashboard.coaches" :key="`coach${index}`" style="cursor: pointer;">
								<div v-b-tooltip.hover :title="getPersonFullName(coach)">
									{{getPersonInitials(coach)}}
								</div>
							</th>
						</thead>
						<tbody>
							<tr v-for="(school, index) in currentDashboard" :key="`school${index}`">
								<td style="white-space: nowrap;">
									{{school.name}}
								</td>
								<td v-for="(visitData, index) in school.visits" :key="`visitData${index}`">
									<template v-if="!visitData.data || !visitData.coachPersonId || visitData.coachPersonId == 0">
									</template>
									<template v-else-if="visitData.data.evaluationsRisk == 1 || visitData.data.keyPostionsRisk == 1">
										<div v-b-tooltip.hover :title="visitData.data.observations || 'Sin observaciones.'" @click="goToIndicatorDetail(visitData.id)" class="d-flex justify-content-center">
											<div class="badge badge-danger" style="color: #dc3545;width: 3rem; height: 3rem;vertical-align:middle;text-align: center;cursor: pointer;">-</div>
										</div>
									</template>
									<template v-else>
										<div v-b-tooltip.hover :title="visitData.data.observations || 'Sin observaciones.'" @click="goToIndicatorDetail(visitData.id)" class="d-flex justify-content-center">
											<div class="badge badge-success" style="color: #28a745;width: 3rem; height: 3rem;vertical-align:middle;text-align: center;cursor: pointer;">-</div>
										</div>
									</template>
								</td>
							</tr>
						</tbody>
					</table>
				</div>
			</div>
		</div>
		<div class="col inner" v-else>
			<spinner :isMiniSpinner="true"/>
		</div>
	</div>
</template>

<script>
import helpers from '@/helpers';
import mediator from '@/mediator';
import Datepicker from 'vuejs-datepicker';

export default {
	timeoutFilter: null,
	filteredItems: null,
	components: {
		Datepicker
	},
	props: ['synthesisTypeId'],
	mounted () {
		setTimeout(() => {
			mediator.showContent();
		}, 1000);
	},
	created () {
		this.startDate = this.$store.state.persistent.academicYear.startDate;
		this.endDate = this.$store.state.persistent.academicYear.endDate;
	},
	data () {
		return {
			startDate: null,
			endDate: null,
			textFilter: '',
			selectedVisit: 1,
			textFilterInputValue: '',
			textFilterQuery: ''
		};
	},
	watch: {
		async synthesisTypeId () {
			this.loadData();
		},
		textFilterInputValue () {
			clearTimeout(this.timeoutFilter);

			if (this.textFilterInputValue === '' || this.textFilterInputValue.length < 3) {
				this.textFilterQuery = '';
				return;
			}

			this.timeoutFilter = setTimeout(() => {
				this.textFilterQuery = this.textFilterInputValue;
			}, 750);
		},
		selectedVisit () {
			this.textFilterInputValue = '';
		}
	},
	computed: {
		dashboard () {
			if (!this.$store.state.admin.synthesesDashboard) return null;
			return this.$store.state.admin.synthesesDashboard;
		},
		currentDashboard () {
			if (!this.dashboard) return null;
			if (!this.filtersApplied) return this.dashboard.report[this.selectedVisit];

			const filteredItems = this.dashboard.report[this.selectedVisit].filter((item) => {
				let match = true;
				if (this.textFilterQuery) match = helpers.textFilter.matchStringFromQuery(this.textFilterQuery, JSON.stringify(item));
				return match;
			});
			console.log(filteredItems);
			return filteredItems;
		},
		visits () {
			if (!this.dashboard) return null;
			return Object.keys(this.dashboard.report).map((visit) => {
				return {
					text: `Visita ${visit}`,
					value: visit
				};
			});
		},
		reportName (item) {
			if (this.synthesisTypeId == 1) return 'Cierres de visita';
			if (this.synthesisTypeId == 2) return 'Formaciones';
			if (this.synthesisTypeId == 3) return 'Diagnóstico actual';
			if (this.synthesisTypeId == 5) return 'Indicadores';
		},
		filtersApplied () {
			return (
				this.textFilterQuery !== ''
			);
		}
	},
	methods: {
		async loadData () {
			this.$store.dispatch('hideContent');
			await mediator.coaching.getAdminSchools();
			await mediator.coaching.getSynthesesDashboardByTypeId(this.synthesisTypeId, this.startDate, this.endDate);
			await this.$store.dispatch('activeMenu', this.$router.currentRoute.path);
			this.$store.dispatch('showContent');
		},
		getHumanDate (date) {
			return helpers.dateTime.getHumanDate(date);
		},
		getHumanDateAndTime (date) {
			return helpers.dateTime.getHumanDateAndTime(date);
		},
		getPersonFullName (person) {
			return helpers.persons.getPersonFullName(person);
		},
		getPersonInitials (person) {
			return helpers.persons.getPersonInitials(person);
		},
		goToIndicatorDetail (indicatorId) {
			this.$router.push(`/coaching/admin/indicator/${indicatorId}`);
		}
	}
};
</script>

<style lang="scss" scoped>
.custom-control-label {
    position: relative;
    margin-bottom: 0;
    cursor: pointer !important;
}
.btn {
	&.btn-outline-primary{
		&.active{
			color: white !important;
		}
	}
}
.btn-group-toggle {
    color: white !important;
}
</style>



// WEBPACK FOOTER //
// src/components/routes/admin/SynthesesDashboard.vue